import { IStoreState, ThunkDispatch } from '../../modules';
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core/styles';

import ExchangesListItem from './ExchangesListItem';
import { List } from 'immutable';
import React from 'react';
import { Record } from '../../modules/tracelog';
import UiList from '@material-ui/core/List';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const styles = (theme: Theme) => createStyles({
  root: {
    paddingTop: 0,
  },
})

const ExchangesList: React.FC<Props> = ({ records: recordsList, classes }) => {

  return (
    <div className={classes.root}>
      <UiList>
        {recordsList.map((r, i) => {
          return (
            <ExchangesListItem
              key={i}
              record={r}
            />
          )
        }).reverse()}
      </UiList>
    </div>
  )
}

const mapStateToProps = ({ auth, intl }: IStoreState) => ({
  auth,
  intl,
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {

    }, dispatch
  )

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {
  records: List<Record>
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ExchangesList))